import { Box, ModalV2, Overlay } from '@pancakeswap/uikit'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { CHAIN_IDS } from 'utils/wagmi'
import { ChainId } from '@pancakeswap/chains'
import { useMemo } from 'react'
import { useNetwork } from 'wagmi'
import { atom, useAtom } from 'jotai'
import { SUPPORT_ONLY_PULSE } from 'config/constants/supportChains'
import dynamic from 'next/dynamic'
import styled from 'styled-components'

export const hideWrongNetworkModalAtom = atom(false)

const ModalBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  // will-change: opacity;
  // opacity: 0;
`

const PageNetworkSupportModal = dynamic(
  () => import('./PageNetworkSupportModal').then((mod) => mod.PageNetworkSupportModal),
  { ssr: false },
)
const WrongNetworkModal = dynamic(() => import('./WrongNetworkModal').then((mod) => mod.WrongNetworkModal), {
  ssr: false,
})
const UnsupportedNetworkModal = dynamic(
  () => import('./UnsupportedNetworkModal').then((mod) => mod.UnsupportedNetworkModal),
  { ssr: false },
)

export const NetworkModal = ({ pageSupportedChains = SUPPORT_ONLY_PULSE }: { pageSupportedChains?: number[] }) => {
  const { chainId, chain, isWrongNetwork } = useActiveWeb3React()
  // const { chains } = useNetwork()
  // const [dismissWrongNetwork, setDismissWrongNetwork] = useAtom(hideWrongNetworkModalAtom)

  // const isScrollOnlyPage = useMemo(() => {
  //   return pageSupportedChains?.length === 1 && pageSupportedChains[0] === ChainId.PULSE
  // }, [pageSupportedChains])

  const isPageNotSupported = useMemo(
    () => Boolean(pageSupportedChains.length) && !pageSupportedChains.includes(chainId!),
    [chainId, pageSupportedChains],
  )
  if (pageSupportedChains?.length === 0) return null // open to all chains

  // if (isPageNotSupported && isScrollOnlyPage) {
  //   return (
  //     // <ModalV2 isOpen closeOnOverlayClick={false}>
  //       <PageNetworkSupportModal />
  //     // </ModalV2>
  //   )
  // }

  // if (isWrongNetwork && !dismissWrongNetwork && !isPageNotSupported) {
  //   const currentChain = chains.find((c) => c.id === chainId)
  //   if (!currentChain) return null
  //   return (
  //     <ModalV2 isOpen={isWrongNetwork} closeOnOverlayClick onDismiss={() => setDismissWrongNetwork(true)}>
  //       <WrongNetworkModal currentChain={currentChain} onDismiss={() => setDismissWrongNetwork(true)} />
  //     </ModalV2>
  //   )
  // }

  if ((chain?.unsupported ?? false) || isWrongNetwork || isPageNotSupported) {
    return (
      <ModalBox>
        <Overlay />
        <UnsupportedNetworkModal pageSupportedChains={pageSupportedChains?.length ? pageSupportedChains : CHAIN_IDS} />
      </ModalBox>
    )
  }

  return null
}
